import React from "react";
import { connect } from 'react-redux';
import MobileWrapper from '../../layouts/MobileWrapper';
import { Card,WingBlank,WhiteSpace } from 'antd-mobile';
import { Calendar,Icon,Spin } from 'antd';
import { fetchCompanyCalendarList } from "../../actions/attendance-actions";
import moment from "moment";
const iconMap = [
	{icon: "", title: ""},
	{icon: "clock-circle-o", title: "其他"},
	{icon: "coffee", title: "休假"},
	{icon: "gift", title: "节日"},
	{icon: "flag", title: "活动"}
];

class MobileCalendar extends React.Component {
	



	componentWillMount () {
		let date = {
			calendar_date: moment().format('YYYY-MM')
		}
		this.setState(date);
		this.props.fetchCompanyCalendarList(date);
		console.log(this.props.attendance)
		setTimeout(() => console.log(this.props.attendance), 3000)
	}

	onPanelChange = moment => {
		let date = {
			calendar_date: moment.format('YYYY-MM')
		}
		this.setState(date);		
		this.props.fetchCompanyCalendarList(date);
	}
	dateCellRender = moment => {
		// console.log(this.props.attendance)
		// let title = "";
		// let content = "";
		let type = 0;
		this.props.attendance.companyCalendar.data.forEach(date => {
			if (date.calendar_date === moment.format('YYYY-MM-DD')) {
				// title = date.title;
				// content = date.content;
				type = date.calendar_type;
			}
		})
		return (
			<div>
				<div>
					<Icon type={iconMap[type].icon} style={{marginLeft: "2px", color: type === 2 ? "red" : ""}} />
				</div>
			</div>
		)
	}
	onSelect = moment => {
		// console.log(moment.format("YYYY-MM-DD"))
		this.setState({
			currentSelectDate:moment.format("YYYY-MM-DD"),
			currentData:1
		})
		// console.log(this.state.currentData);
		this.props.attendance.companyCalendar.data.forEach(date => {
			if (date.calendar_date === moment.format('YYYY-MM-DD')) {
				this.setState({
					currentData: {
						...date,
						icon: iconMap[date.calendar_type]
					}
				})
				return;
			}
		})
		// console.log(this.props.attendance.companyCalendar.data)
		// console.log(this.state.currentData)
	}
	render() {
		return (
			<div>
			{this.props.attendance.companyCalendar.dataStatus === "loaded" ?
				<div className="calendarDiv" style={{ border: '1px solid #d9d9d9', borderRadius: 4}}>
				    <Calendar fullscreen={true}
				    	 dateCellRender={this.dateCellRender}
				    	 onPanelChange={this.onPanelChange} 
						 onSelect={this.onSelect} 
				    	 />
				</div>
				: <Spin />
			}
			<div>
				<div className="attendance-calendar" style={{border: "1px solid #e5e5e5", borderRadius: "3px",paddingTop:"10px"}}>
					<span style={{height: "40px", lineHeight: "40px",margin: "0px 15px"}}>注:</span>
					{iconMap.map(icon => (
						<span key={icon.icon} style={{margin: "15px",fontSize:"14px"}}>
							<Icon type={icon.icon}> {icon.title}</Icon>
						</span>
					))}
				</div>
				
				<div>
					<WingBlank size="lg">
					    <WhiteSpace size="lg" />
					    <Card>
					      <Card.Header
					        title="公司行事历"
					        extra={<span>{this.state.currentSelectDate&&this.state.currentSelectDate}</span>}
					      />
					      {this.state.currentData && this.state.currentData!==1 ? 
					      <Card.Body>
					        <div>标题： {this.state.currentData.title}</div>
					        <div>内容： {this.state.currentData.content}</div>
					      </Card.Body>
					      :
					      <Card.Body>
					        <div>暂无内容</div>
					      </Card.Body>
					      }
					      <Card.Footer/>
					    </Card>
					    <WhiteSpace size="lg" />
					  </WingBlank>
				</div>
			</div>
				
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		attendance: state.attendance,
	}
}

const mapDispatchToProps = {
	fetchCompanyCalendarList
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileCalendar));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileCalendar.js